import { createFileRoute } from '@tanstack/react-router'
import { myApplicationSearchSchema } from '@/features/applications/filter-my-applications/model/myApplicationSearch'
import { MyApplicationsPage } from '@/pages/applications/ui/MyApplicationsPage'

export const Route = createFileRoute('/my-applications')({
  validateSearch: myApplicationSearchSchema,
  component: MyApplicationsPage,
})
